import { createContext, useContext } from "react";
const initialValue = {
    settings: {},
    onSettingsChange: () => null,
    getShownColumns: () => []
};
const TableContext = createContext(initialValue);
export const useTableContext = () => useContext(TableContext);
export default TableContext;
